import React, { Component } from "react";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import Cliente from "./Cliente";
import "./admin.css";
import Podcast from "./Podcast";
import Pedidos from "./Pedidos";
class Admin extends Component{

  render() {
    return(
      <div>
        <div className={"sidebar"}>
         <ul>
           <li><Link to={"/admin/"}>Clientes</Link></li>
           <li><Link to={"/admin/podcasts/"}>Áudios</Link></li>
           <li><Link to={"/admin/podcasts/pedidos/"}>Pedidos</Link></li>
         </ul>
        </div>
        <div className={"content"}>
          <Route exact path={"/admin/"} component={Cliente} />
          <Route exact path={"/admin/podcasts/"} component={Podcast} />
          <Route exact path={"/admin/podcasts/pedidos"} component={Pedidos} />
        </div>
      </div>
    )
  }
}

export default Admin;
